import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListCandidatsComponent } from './components/list-candidats/list-candidats.component';
import { CompareCandidatsComponent } from './components/compare-candidats/compare-candidats.component';
import { ResultsCompareComponent } from './components/results-compare/results-compare.component';
import { ProfilcandidatComponent } from './components/profilcandidat/profilcandidat.component';
import { ContacterComponent } from './components/contacter/contacter/contacter.component';
import { CvCandidatComponent } from './components/cv-candidat/cv-candidat.component';
import { esnAbonneeGuard } from '@core/guards/esn-abonnee.guard';
import { SubscriptionHasFeatureGuard } from 'app/guards/subscription-has-feature.guard';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'list-candidats',
    pathMatch: 'full',
  },
  {
    path:'list-candidats',
    component:ListCandidatsComponent,
  },
  // canActivate: [esnAbonneeGuard.canActivate]

  {
    path:'compare-candidats',
    component:CompareCandidatsComponent,
    canActivate: [SubscriptionHasFeatureGuard],
    data: { featureName: 'Comparaison' },
  },
  {
    path:'result-compare',
    component:ResultsCompareComponent,
    canActivate: [SubscriptionHasFeatureGuard],
    data: { featureName: 'Comparaison' },
  },
  {
    path:'profilecandidatesn/:id',
    component:ProfilcandidatComponent,
  },
  {
    path:'contacter/:id',
    component:ContacterComponent,
  },
  {
    path:'Cv-candidat',
    component:CvCandidatComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CandidatsRoutingModule { }
